import Model, { valueWithArray } from 'ducker-model';
import tool from '@/utils/tool';

const property = {
  noticeList: valueWithArray(Object),
};

const replacedKeyFromPropertyName = {
  noticeList: {
    property: 'list',
    computed: (list) => {
      const handleSubTitle = (type, date) => {
        const configMap = ['发行运作', '分红送配', '定期报告', '人事调整', '基金销售', '其他公告'];
        const typeText = configMap[type - 1] || '';
        const dateText = tool.formatDateTime(date, true);
        return `${typeText} ${dateText}`;
      };
      if (list?.length) {
        const temp = [];
        list.forEach((item) => {
          temp.push({
            title: item.title,
            subTitle: handleSubTitle(item.new_column_code, item.notice_date),
            articleCode: item.art_code,
          });
        });
        return temp;
      }
      return [];
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
